import { ReactNode } from 'react';
import parse, { DOMNode, HTMLReactParserOptions } from 'html-react-parser';

export const convertRecentUpdatesContentToReactElement = (
  helpContent: string
): ReactNode => {
  const options: HTMLReactParserOptions = {
    replace: (domNode: DOMNode) => {
      if (domNode.cloneNode.name === 'br') {
        return null;
      }
    },
  };
  return parse(helpContent, options);
};
